// Messaging Users
export const GET_MESSAGING_USERS_REQUEST = 'GET_MESSAGING_USERS_REQUEST'
export const GET_MESSAGING_USERS_SUCCESS = 'GET_MESSAGING_USERS_SUCCESS'
export const GET_MESSAGING_USERS_FAIL = 'GET_MESSAGING_USERS_FAIL'
export const GET_MESSAGING_USERS_RESET = 'GET_MESSAGING_USERS_RESET'

// Send Direct Message
export const SEND_DIRECT_MESSAGE_REQUEST = 'SEND_DIRECT_MESSAGE_REQUEST'
export const SEND_DIRECT_MESSAGE_SUCCESS = 'SEND_DIRECT_MESSAGE_SUCCESS'
export const SEND_DIRECT_MESSAGE_FAIL = 'SEND_DIRECT_MESSAGE_FAIL'
export const SEND_DIRECT_MESSAGE_RESET = 'SEND_DIRECT_MESSAGE_RESET'

// Message Templates
export const GET_MESSAGE_TEMPLATES_REQUEST = 'GET_MESSAGE_TEMPLATES_REQUEST'
export const GET_MESSAGE_TEMPLATES_SUCCESS = 'GET_MESSAGE_TEMPLATES_SUCCESS'
export const GET_MESSAGE_TEMPLATES_FAIL = 'GET_MESSAGE_TEMPLATES_FAIL'
export const GET_MESSAGE_TEMPLATES_RESET = 'GET_MESSAGE_TEMPLATES_RESET'

// User Message History
export const GET_USER_MESSAGE_HISTORY_REQUEST = 'GET_USER_MESSAGE_HISTORY_REQUEST'
export const GET_USER_MESSAGE_HISTORY_SUCCESS = 'GET_USER_MESSAGE_HISTORY_SUCCESS'
export const GET_USER_MESSAGE_HISTORY_FAIL = 'GET_USER_MESSAGE_HISTORY_FAIL'
export const GET_USER_MESSAGE_HISTORY_RESET = 'GET_USER_MESSAGE_HISTORY_RESET'

// Vouchers (Keeping these as they might be used by client app or other parts)
export const CLAIM_VOUCHER_REQUEST = 'CLAIM_VOUCHER_REQUEST'
export const CLAIM_VOUCHER_SUCCESS = 'CLAIM_VOUCHER_SUCCESS'
export const CLAIM_VOUCHER_FAIL = 'CLAIM_VOUCHER_FAIL'
export const CLAIM_VOUCHER_RESET = 'CLAIM_VOUCHER_RESET'

export const GET_VOUCHER_STATUS_REQUEST = 'GET_VOUCHER_STATUS_REQUEST'
export const GET_VOUCHER_STATUS_SUCCESS = 'GET_VOUCHER_STATUS_SUCCESS'
export const GET_VOUCHER_STATUS_FAIL = 'GET_VOUCHER_STATUS_FAIL'
export const GET_VOUCHER_STATUS_RESET = 'GET_VOUCHER_STATUS_RESET'

export const GET_MY_VOUCHERS_REQUEST = 'GET_MY_VOUCHERS_REQUEST'
export const GET_MY_VOUCHERS_SUCCESS = 'GET_MY_VOUCHERS_SUCCESS'
export const GET_MY_VOUCHERS_FAIL = 'GET_MY_VOUCHERS_FAIL'
export const GET_MY_VOUCHERS_RESET = 'GET_MY_VOUCHERS_RESET'
